(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-pdp-gallery]').forEach(gallery => {
      if (gallery.dataset.initialized) return;
      gallery.dataset.initialized = 'true';
      const image = gallery.querySelector('.pdp-gallery__main');
      const thumbs = [...gallery.querySelectorAll('[data-pdp-thumb]')];
      const position = gallery.querySelector('[data-pdp-position]');
      let selected = 0;
      const show = index => {
        selected = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[selected];
        image.srcset = thumb.dataset.srcset;
        image.src = thumb.dataset.image;
        image.alt = thumb.dataset.alt;
        thumbs.forEach((item, i) => item.setAttribute('aria-pressed', String(i === selected)));
        position.textContent = `${selected + 1} / ${thumbs.length}`;
      };
      thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => show(index));
        thumb.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          show(selected + (event.key === 'ArrowRight' ? 1 : -1));
          thumbs[selected].focus();
        });
      });
      gallery.querySelector('[data-pdp-prev]').addEventListener('click', () => show(selected - 1));
      gallery.querySelector('[data-pdp-next]').addEventListener('click', () => show(selected + 1));
      let start = null;
      image.addEventListener('pointerdown', event => { start = {x:event.clientX, y:event.clientY}; }, {passive:true});
      image.addEventListener('pointerup', event => {
        if (!start) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(selected + (dx < 0 ? 1 : -1));
        start = null;
      }, {passive:true});
      image.addEventListener('pointercancel', () => { start = null; }, {passive:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
